import { BriefcaseCheckIcon } from './BriefcaseCheckIcon';

/**
 * author: Google
 * id 4182182E-F79B-4153-B652-2A4B4AC231E1
 * name briefcase-check
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/briefcase-check.svg
 * tags
 */
export const BriefcaseTickIcon = BriefcaseCheckIcon;
export default BriefcaseTickIcon